import React from 'react';
import classnames from 'classnames';
import ismobilejs from 'ismobilejs';
import videojs from 'video.js/dist/video.js';
import 'video.js/dist/video-js.css';

import Gallery from './Gallery';

import image1 from '../images/Generator-1.jpg';
import image2 from '../images/Generator-2.jpg';
import image3 from '../images/Generator-3.jpg';
import image4 from '../images/Generator-4.jpg';
import mp4Video from '../videos/Generator-video.mp4';
import webmVideo from '../videos/Generator-video.webm';

import '../styles/Generator.css';

class Generator extends React.Component {

  state = {
    selectedGalleryIdx: 0
  };

  render() {
    return (
      <div className={classnames('Generator', this.props.className)}>
        <div className="Generator-content">
          {
            !ismobilejs.any &&
            <div className="Generator-videoWrapper">
              <video
                ref="videoNode"
                id="Generator-video"
                className="Generator-video video-js"
                autoPlay
                loop
                width="512px"
                height="512px"
                data-setup='{
                }'>
                <source
                  src={mp4Video}
                  type="video/mp4"
                />
                <source
                  src={webmVideo}
                  type="video/webm"
                />
              </video>
            </div>
          }
          <h2 className="Generator-title">
            {`Scherk-Collins Sculpture Generator II`}
          </h2>
          <div className="Generator-galleryContainer">
            <Gallery
              className="Generator-gallery"
              items={[
                { image: image2 },
                { image: image1 },
                { image: image3 },
                { image: image4 }
              ]}
              onUpdateIdx={this._onUpdateGalleryIdx}
              metricsName="Generator"
            />
            <div className="Generator-descriptionContainer">
              <h2 className="Generator-mobileTitle">
                {`Scherk-Collins Sculpture Generator II`}
              </h2>
              <div className="Generator-description">
                {`Scherk-Collins Sculpture Generator II is a virtual prototyping program to generate Hyperbolic Hexagon (a toroidal ring of the central hole-saddle column). The original Sculpture Generator I was developed by Professor Sequin and Houman Meshkin in 1995 and was implemented for IRIX OS using IRIS GL.\n\n`}
                {`As an undergraduate researcher in UC Berkeley Computer Graphics Group, I ported the old generator to today's common environment such as Open GL and Windows. I extended the program with the addition of a new warping function that allows the hole-saddle chain to follow an arbitrary B-spline curve given by a set of control points. In other words, `}
                <span className={classnames('Generator-descriptionHighlight', {
                  highlight: this.state.selectedGalleryIdx === 2
                })}>
                  {`the generator II can build any shape, `}
                </span>
                {`while the old generator can build only a straight tower or circle-shaped sculpture.\n\n`}
                {`The generator is not just a general purpose 3D graphics modeling program but a precise special-purpose generator that produces `}
                <span className={classnames('Generator-descriptionHighlight', {
                  highlight: this.state.selectedGalleryIdx === 3
                })}>
                  {`"watertight" manifold meshes suitable for layered manufacturing or NC-machining (e.g. FDM Machine).`}
                </span>
                {` A sculptor Brent Collin and Professor Sequin constructed `}
                <span className={classnames('Generator-descriptionHighlight', {
                  highlight: this.state.selectedGalleryIdx === 1
                })}>
                  {`a 10 foot diameter sculpture of Evolving Trefoil generated in my program for a new Science Building of Missouri Western State University in St. Joseph, MO.`}
                </span>
              </div>
              <div className="Generator-specContainer">
                {
                  [
                    { title: 'C++' },
                    { title: 'OpenGL' },
                    { title: 'Math' }
                  ].map(({ title }, idx) => (
                    <div
                      key={idx}
                      className="Generator-spec">
                      {title}
                    </div>
                  ))
                }
                <a
                  className="Generator-link"
                  href={`http://graphics.berkeley.edu/`}
                  target="_blank"
                  rel="noopener noreferrer">
                  {`grahpics.berkeley.edu`}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    if (ismobilejs.any) {
      return;
    }

    videojs('Generator-video', {}, () => {});
  }

  _onUpdateGalleryIdx = (idx) => {
    this.setState({
      selectedGalleryIdx: idx
    });
  };

}

export default Generator;



// WEBPACK FOOTER //
// ./src/components/Generator.js